module.exports = __webpack_public_path__ + "img/advantage-8.03dab8e4.png";